import React, { useEffect, useState } from 'react'
import { QuestionPlusText } from './QuestionPlusText/QuestionPlusText'
import { Variants } from './Variants/Variants'
import { CompleteSentence } from './CompleteSentence/CompleteSentence'
import { TextMissingWords } from './TextMissingWords/TextMissingWords'
import { WordMatching } from './WordMatching/WordMatching'
import { WordsInBlanks } from './WordsInBlanks/WordsInBlanks'
import { MatchWordsImages } from './MatchWordsImages/MatchWordsImages'
import { MakeWordFromLetters } from './MakeWordFromLetters/MakeWordFromLetters'
import { Essay } from './Essay/Essay'
import { ImageMatching } from './ImageMatching/ImageMatching'
import { SortSentences } from './SortSentences/SortSentences'
import { QuestionImageVariants } from './QuestionImageVariants/QuestionImageVariants'
import asideModalStore from 'Stores/asideModalStore'
import styles from './Variants/Variants.module.scss'
import useLocalization from 'hooks/useLocalization'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'
import PointsModal from './Modals/PointsModal'

export const CustomAnswer = ({ question, answer, item, updateResults }) => {
  const { translate } = useLocalization({
    section: 'study',
    subsection: 'tests',
    dict: {
      numberOfPoints: 'Number of points',
      comment: 'Comment',
      add_point: 'Add point',
      save: 'Save',
    },
  })

  const [pointsData, setPointsData] = useState({
    employee_points: answer?.employee_points || '',
    employee_comment: answer?.employee_comment || '',
  })

  const [updatedComment, setUpdatedComment] = useState(null)
  const [commentToShow, setCommentToShow] = useState('')

  useEffect(() => {
    if (updatedComment?.[answer?.id]) {
      setCommentToShow(updatedComment?.[answer?.id])
    } else {
      setCommentToShow(answer?.employee_comment)
    }
  }, [answer?.id, updatedComment])

  const onBeforeSubmit = (data) => {
    return {
      link: `study/set_student_answer_points/${answer?.id}`,
      body: data,
    }
  }

  const addPoint = () => {
    const modalSettings = {
      modalBodyComponent: () => (
        <PointsModal
          initialPoints={answer?.employee_points || ''}
          initialComment={answer?.employee_comment || ''}
        />
      ),
      button: translate?.save,
      link: `study/set_student_answer_points/${pointsData?.id}`,
      title: translate?.add_point,
      isResponsive: true,
      is_put: true,
      onBeforeSubmit,
      onSubmitSuccess: (data) => {
        setUpdatedComment({
          [answer?.id]: data?.employee_comment,
        })
        setPointsData({
          employee_points: data.employee_points,
          employee_comment: data.employee_comment,
        })
      },
      valid: {},
    }
    asideModalStore.activity(modalSettings, {})
  }

  const customAnswers = {
    question_plus_text: (
      <QuestionPlusText question={question} answer={answer} />
    ),
    variants: <Variants question={question} answer={answer} />,
    audio_plus_variants: <Variants question={question} answer={answer} />,
    video_plus_variants: <Variants question={question} answer={answer} />,
    complete_sentence: <CompleteSentence question={question} answer={answer} />,
    text_missing_words: (
      <TextMissingWords question={question} answer={answer} />
    ),
    word_matching: <WordMatching question={question} answer={answer} />,
    words_in_blanks: <WordsInBlanks question={question} answer={answer} />,
    match_words_images: (
      <MatchWordsImages question={question} answer={answer} />
    ),
    image_matching: <ImageMatching question={question} answer={answer} />,
    drag_words_in_blanks: <WordsInBlanks question={question} answer={answer} />,
    make_word_from_letters: (
      <MakeWordFromLetters question={question} answer={answer} />
    ),
    essay: <Essay question={question} answer={answer} item={item} />,
    sort_sentences: <SortSentences question={question} answer={answer} />,
    question_image_variants: (
      <QuestionImageVariants question={question} answer={answer} />
    ),
  }

  return (
    <>
      {customAnswers[question.type]}
      <div className={styles.btnContainer}>
        <div className={styles.btsForPoints}>
          <SuperButton onClick={addPoint} type={'linkColored'} variant={'edit'}>
            {translate?.add_point}
          </SuperButton>
        </div>
        {commentToShow && (
          <div className={styles.comments}>
            <div className={styles.comment}>{translate?.comment}:</div>
            <div className={styles.textContainer}>
              <div className={styles.textOfComments}>{commentToShow}</div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
